import { DEFAULT_BADGE_ICON } from '../services/progressionAdminApi';

export const ADMIN_BADGE_ICON_SIZE = 44;

export function isDefaultBadgeIcon(icon?: string) {
  return !icon || icon === DEFAULT_BADGE_ICON;
}

/**
 * Image src for badge artwork.
 * Always use relative `/api/v1/files/...` — admin Vite dev proxy and prod nginx
 * forward `/api` to the API server on the same browser origin.
 */
export function resolveBadgeIconSrc(icon?: string): string | null {
  if (isDefaultBadgeIcon(icon)) return null;
  if (icon!.startsWith('http')) {
    const apiBase = ((import.meta.env.VITE_API_BASE_URL as string) || '').replace(/\/$/, '');
    if (apiBase && icon!.startsWith(apiBase)) {
      return icon!.slice(apiBase.length) || null;
    }
    return icon!;
  }
  return icon!;
}
